import React from 'react';
import { Typography, makeStyles, createStyles } from "@material-ui/core";
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(({ pageTitle, textCenter }) => createStyles({
  pageTitle,
  textCenter,
}));

export default function NotFound() {
  const classes = useStyles();
  return (
    <div className={classes.textCenter}>
      <Typography variant="h1" className={classes.pageTitle}>
        <FormattedMessage id="notFound.title" />
      </Typography>
      <p>
        <FormattedMessage id="notFound.title.listItem1" />
      </p>
      <p>
        <FormattedMessage id="notFound.title.listItem2" />
      </p>
    </div>
  );
}
